import { QUERY_PARAM_ROUTES } from '../../../utils/constants/QueryParamRoutes';

export const BASE_RESERVATIONS_PATHNAME = QUERY_PARAM_ROUTES.RESERVATION_LIST;

export const RESERVATIONS_TYPE = Object.freeze({
  PAST: 'past',
  UPCOMING: 'upcoming',
});
